import {
  initialState,
  Actions,
  State,
  NEW_CALENDAR,
  NEW_CALENDAR_SUCCESS,
  NEW_CALENDAR_ERROR,
  RESET_NEW_CALENDAR,
} from "../../types/calendar/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CALENDAR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_CALENDAR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_CALENDAR_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_CALENDAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
